import $ from "cash-dom";

$(function () {

    var emulateLink = function (href, clickedElement) {
        if (typeof href === 'undefined' || !href.length) {
            href = clickedElement.data('href');
        }

        if (!href) {
            return;
        }

        var target = clickedElement.data('target');

        if (target === 'blank') {
            var a = $('<a>').attr({
                'href': href,
                'target': '_blank',
                'id': 'link_for_click'
            });

            if (typeof clickedElement.attr('data-rel') !== 'undefined') {
                a.attr('rel', clickedElement.attr('data-rel'));
            } else if (href.indexOf('/go/vendor/') >= 0 || href.indexOf('/go/youtube/') >= 0) {
                a.attr('rel', 'sponsored nofollow noopener noreferrer');
            } else if (href.indexOf(window.location.origin) !== 0) {
                a.attr('rel', 'nofollow noopener noreferrer');
            }

            if (typeof clickedElement.data('ga-event') !== 'undefined') {
                a.attr('data-ga-event', clickedElement.data('ga-event'));
            }

            if (typeof clickedElement.data('ga-label') !== 'undefined') {
                a.attr('data-ga-label', clickedElement.data('ga-label'));
            }

            if (typeof clickedElement.data('ga-prefix') !== 'undefined') {
                a.attr('data-ga-prefix', clickedElement.data('ga-prefix'));
            }

            if (typeof clickedElement.data('ga-suffix') !== 'undefined') {
                a.attr('data-ga-suffix', clickedElement.data('ga-suffix'));
            }

            if (typeof clickedElement.attr('title') !== 'undefined') {
                a.attr('title', clickedElement.attr('title'));
            }

            if (typeof clickedElement.attr('data-title') !== 'undefined') {
                a.attr('data-title', clickedElement.attr('data-title'));
            }

            if (typeof clickedElement.attr('data-btn-name') !== 'undefined') {
                a.attr('data-btn-name', clickedElement.attr('data-btn-name'));
            }

            $(document.body).append(a);
            $('#link_for_click')[0].click();
            $('#link_for_click').remove();
        } else {
            if (typeof GAEvents !== 'undefined') {
                GAEvents.trackClick(clickedElement.get(0));
            }
            window.location.href = href;
        }
    }

    $(document).on('click', '[data-href]', function (e) {
        var targetTag = $(e.target).prop("tagName");

        if ($(e.target).hasClass('unbind-data-href') ||
            $(e.target).parent('.unbind-data-href').length ||
            $(this).hasClass('unbind-data-href') ||
            ['INPUT', 'SELECT', 'TEXTAREA'].indexOf(targetTag) >= 0)
        {
            return;
        }

        emulateLink('', $(this));
    });
});